import React from 'react'
import WithLabel from '../WithLabel'
import Textarea from '../Textarea'

/**
 * The [Textarea](#Textarea) component with a label.
 */
const LabeledTextarea = props => (
  <WithLabel stretch {...props}>
    {props => <Textarea {...props} />}
  </WithLabel>
)

LabeledTextarea.defaultProps = {
  color: 'light',
}

export default LabeledTextarea
